module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Ruth Bader Ginsburg: In Her Own Words")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "bodymatter",
      "title": "Part I: The Law"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "pa1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rpa1"
    }
  }, [_vm._v("Part I")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rpa1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "291",
      "src": "images/pa1.jpg",
      "width": "291"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c425374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Part01.vue
// module id = 78
// module chunks = 0